import { motion } from 'framer-motion';

const clients = [
  { name: 'La Maison du Fromage', country: 'France' },
  { name: 'Tech Solutions Inc', country: 'USA' },
  { name: 'Maple Craft Brewery', country: 'Canada' },
  { name: 'InduTech', country: 'Luxembourg' },
  { name: 'BeautyGlam', country: 'Belgique' },
  { name: 'Gusto Italiano', country: 'Italie' },
  { name: 'Swiss Watches Direct', country: 'Suisse' },
  { name: 'Beachside Surf Co.', country: 'Australie' },
  { name: 'Playa del Sol Resort', country: 'Espagne' },
  { name: 'TechHealth', country: 'Monaco' },
  { name: 'AutoTech GmbH', country: 'Allemagne' },
  { name: 'ProServ', country: 'Nouvelle Zélande' },
];

const Clients = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Fond avec dégradé subtil */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-neon-orange/5 to-white pointer-events-none" />
      
      {/* Cercles décoratifs */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-neon-orange/5 rounded-full blur-3xl animate-pulse-glow" />
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-neon-orange/5 rounded-full blur-3xl animate-pulse-glow" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="section-title">
            Approuvé par les entreprises et les partenaires du monde entier
          </h2>
          <p className="section-subtitle">
            Nous avons aiguisé nos compétences numériques avec plus de 3500 entreprises, marques et startups dans plus de 12 pays, faisant de nous le véritable couteau suisse digital.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {clients.map((client, index) => (
            <motion.div
              key={client.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-neon-orange/10 to-transparent rounded-xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative bg-white/80 backdrop-blur-sm p-6 rounded-xl text-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                <div className="font-medium text-gray-900">{client.name}</div>
                <div className="text-sm text-gray-500">{client.country}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;